import './Switch.scss'
import {v4 as uuidv4} from 'uuid'

const Switch = (props) => {
  const uuid = uuidv4()
  return (
    <div class={`switch-container ${props.tooltip ? 'tooltip' : ''} ${props.tooltipPosition || ''} ${props.disabled ? 'disabled' : ''}`} data-tooltip={props.tooltip || ''}>
      <p class={`bill-choice ${props.checked ? '' : 'active'}`}>
        {props.left}
      </p>
      <div>
        <input className="plan-switch" type="checkbox" hidden id={`plan-switch-${uuid}`} {...props} />
        <label for={`plan-switch-${uuid}`}>Toggle</label>
      </div>
      <p class={`bill-choice ${props.checked ? 'active' : ''}`}>
      {props.right}
      </p>
    </div>
  )
}

export default Switch
